/* eslint-disable react-hooks/exhaustive-deps */
import { HStack, Box, Center, position, Text, VStack, Tooltip, Button, Skeleton, Grid, Spacer } from "@chakra-ui/react"
import { useContext, useEffect, useMemo } from "react"
import { useState } from "react"
import CQLineChart from "../../../components/CQLineChart"
import AppColors from "../../../constants/AppColors"
import { FONT_FAMILY } from "../../../constants/Theme"
import {
    CQSelect,
} from '@laxmimanogna/code-quick-components';
import Select from 'react-select';
import { DashboardContext } from "../../../providers/DashboardProvider"
import { RepeatIcon } from '@chakra-ui/icons';

const DropdownComponent = ({
  options,
  setSelected,
  selected,
  placeholder = "Select Options",
  isDisabled=false,
  disabledText = "Dropdown disabled",
  isLoading=false,
  isClearable=true,
  isSearchable=true
}) => {
  const handleChange = (option) => {
    setSelected(option);
  }

  return (
    <div
    style={{
      flex:1,
    }}>
      <Select 
      options={options}
      onChange={handleChange}
      isClearable={isClearable}
      placeholder={placeholder}
      isDisabled={isDisabled}
      value={selected}
      isLoading={isLoading}
      isSearchable={isSearchable}
      /> 
    </div> 
  )
}


const RVUOpportunityV2 = ({ 
    practiceChartData, 
    auditChartData, 
    stateChartData, 
    extraRVUData, 
    setChecked,
    radioClick, 
    checked, 
    tile, 
    dropdown, 
    weightedAvgData 
}) => {
    const [isHovering, setIsHovering] = useState(false);
    const dashboardContext = useContext(DashboardContext);
    const [extraDetails, setExtraDetails] = useState({})
    const [rvuFetchTrigger, setRVUFetchTrigger] = useState(0);

    const {
        stateSpecialtiesMapping,
        getStateSpecialtiesMap,
        getAllStates,
        getAllSpecialties,
        allStates,
        allSpecialties,
        getRVUOpp,
        filterParams,
        rvuOppFilter,
        setRVUOppFilter,
        isRVUOppLoading,
        eandmSelectedOptions,
        setEandMSelectedOptions,
        DEFAULT_CLIENT_STATE,
        DEFAULT_CLIENT_SPECIALTY,
        DEFAULT_CMS_STATE,
        DEFAULT_CMS_SPECIALTY,
        isRVUOppDropdownLoading,
        DEFAULT_EANDM_OPTIONS,
        DEFAULT_RVU_DOPDOWN,rvuOpp
    } = dashboardContext


    
    useEffect(() => {
        getStateSpecialtiesMap();
        getAllStates();
        getAllSpecialties();
    }, [])

    const tileLoader = () => {
        return (
          <Box mx={3}>
            <Skeleton mt={5} w={'100%'} h={25} borderRadius="md" />
            <Skeleton mt={10} w={'100%'} h={200} borderRadius="md" />
            <Skeleton my={5} w={'50%'} h={25} borderRadius="md" />
          </Box>
        );
      };

    useEffect(() => {
        if (!eandmSelectedOptions?.selectedClientState) {
            return;
        }
        let newStates = eandmSelectedOptions?.selectedClientState;
        if (newStates?.value) {
            newStates = [newStates?.label];
        } else {
            newStates = (stateSpecialtiesMapping?.order ?? []).filter(Boolean).map(id => stateSpecialtiesMapping?.states?.[id]?.name);
        }
        setExtraDetails(prev => ({...prev, clientStates: newStates}))
        setRVUOppFilter(prev => ({
        ...prev, 
        billed_state_id: eandmSelectedOptions?.selectedClientState.value,
        reviewed_state_id: eandmSelectedOptions?.selectedClientState.value
    }))}, [eandmSelectedOptions?.selectedClientState, stateSpecialtiesMapping]);

    useEffect(() => {
        if (!eandmSelectedOptions?.selectedClientSpecialty) {
            return;
        }
        let newSpecs = eandmSelectedOptions?.selectedClientSpecialty;
        if (newSpecs?.value) {
            newSpecs = [newSpecs?.label];
        } else {
            newSpecs = ((stateSpecialtiesMapping?.states ?? [])[eandmSelectedOptions?.selectedClientState.value]?.specialties ?? [])
                    .filter(spec => !!spec.id)
                    .map(spec => spec.name);
        }

        setExtraDetails(prev => ({...prev, clientSpecalties: newSpecs}))
        
        setRVUOppFilter(prev => ({
        ...prev, 
        billed_specialty_id: eandmSelectedOptions?.selectedClientSpecialty.value,
        reviewed_specialty_id: eandmSelectedOptions?.selectedClientSpecialty.value
    }))}, [eandmSelectedOptions?.selectedClientSpecialty, stateSpecialtiesMapping]);

    useEffect(() => setRVUOppFilter(prev => ({...prev, cms_state_id: eandmSelectedOptions?.selectedCMSState.value})), [eandmSelectedOptions?.selectedCMSState])
    useEffect(() => setRVUOppFilter(prev => ({...prev, cms_specialty_id: eandmSelectedOptions?.selectedCMSSpecialty.value})), [eandmSelectedOptions?.selectedCMSSpecialty])

    const commonSelectStyles = {
        control: props => ({
            ...props,
            borderRadius: 7,
            paddingRight: 10,
            paddingLeft: 10,
            fontSize: '12px',
            color: AppColors.secondary,
            borderColor: AppColors.secondary,
            '&:hover': {
                borderColor: AppColors.primary,
            },
        }),
        placeholder: props => ({
            ...props,
            color: AppColors.secondary,
            fontWeight: 'bold'
        }),
        dropdownIndicator: props => ({
            ...props,
            color: AppColors.secondary
        }),
        singleValue: props => ({
            ...props,
            fontWeight: 'bold',
            color: AppColors.secondary,
        }),
        option: props => ({
            ...props,
            fontSize: '12px',
            zIndex: 100
        }),
        menu: props => ({
            ...props,
            zIndex: 100
        }),
    }

    useEffect(() => {
        if (!tile && rvuFetchTrigger) {
          // rvuOpp is depended on rvuOppFilter and filterParams. No need to useState on filterParams as change in filterParams changes rvuOppFilter
          // which eventually calls this useState. So, we need to avoid needless redundant api calls
          getRVUOpp();
        }
      }, [rvuFetchTrigger])

    return <Box position="relative">
        {/* Compact horizontal bar with dots and percentages */}
        {isRVUOppLoading ? tileLoader(): (
            <>
            {weightedAvgData && (
            <Box 
                position="absolute" 
                top="-5%"
                right="1%"
                zIndex={5}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            >
                {!isHovering ? (
                    // Collapsed State - Compact with dots and percentages
                    <HStack
                        cursor="pointer"
                        spacing="0.4em"
                        padding="clamp(3px, 0.5vh, 5px) clamp(6px, 0.8vw, 8px)"
                    >
                        {weightedAvgData.practice !== undefined && (
                            <HStack spacing="0.2em">
                                <Box 
                                    w="clamp(4px, 0.6vw, 6px)"
                                    h="clamp(4px, 0.6vw, 6px)"
                                    borderRadius="full" 
                                    bg={AppColors.primary}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="10px"
                                >
                                    {weightedAvgData.practice}
                                </Text>
                            </HStack>
                        )}
                        {weightedAvgData.revintegrity !== undefined && (
                            <HStack spacing="0.2em">
                                <Box 
                                    w="clamp(4px, 0.6vw, 6px)"
                                    h="clamp(4px, 0.6vw, 6px)"
                                    borderRadius="full" 
                                    bg={AppColors.secondary}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="10px"
                                >
                                    {weightedAvgData.revintegrity}
                                </Text>
                            </HStack>
                        )}
                        {weightedAvgData.state !== undefined && (
                            <HStack spacing="0.2em">
                                <Box 
                                    w="clamp(4px, 0.6vw, 6px)"
                                    h="clamp(4px, 0.6vw, 6px)"
                                    borderRadius="full" 
                                    bg={AppColors.gray}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="10px"
                                    // fontWeight="600"
                                    // color={AppColors.gray}
                                >
                                    {weightedAvgData.state}
                                </Text>
                            </HStack>
                        )}
                    </HStack>
                ) : (
                    // Expanded State - Details box
                    <VStack 
                        bg="rgba(255, 255, 255, 0.9)"
                        padding="clamp(8px, 1.5vh, 14px) clamp(10px, 1.5vw, 14px)"
                        spacing="clamp(4px, 0.8vh, 6px)"
                        align="stretch"
                        minW="clamp(110px, 15vw, 140px)"
                        borderRadius="clamp(4px, 0.6vw, 6px)"
                        boxShadow="0 2px 8px rgba(0,0,0,0.1)"
                    >
                        <Text 
                            fontSize="clamp(10px, 1.3vw, 12px)"
                            fontWeight="bold" 
                            color={AppColors.secondary}
                            textAlign="center"
                            mb="clamp(2px, 0.4vh, 4px)"
                        >
                            Weighted Avg
                        </Text>
                        {weightedAvgData.practice !== undefined && (
                            <HStack spacing="clamp(4px, 0.6vw, 6px)">
                                <Box 
                                    w="clamp(6px, 0.8vw, 7px)"
                                    h="clamp(6px, 0.8vw, 7px)"
                                    borderRadius="full" 
                                    bg={AppColors.primary}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="clamp(9px, 1.2vw, 11px)"
                                    color="gray.700"
                                >
                                    Practice: <strong>{weightedAvgData.practice}</strong>
                                </Text>
                            </HStack>
                        )}
                        {weightedAvgData.revintegrity !== undefined && (
                            <HStack spacing="clamp(4px, 0.6vw, 6px)">
                                <Box 
                                    w="clamp(6px, 0.8vw, 7px)"
                                    h="clamp(6px, 0.8vw, 7px)"
                                    borderRadius="full" 
                                    bg={AppColors.secondary}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="clamp(9px, 1.2vw, 11px)"
                                    color="gray.700"
                                >
                                    Audit: <strong>{weightedAvgData.revintegrity}</strong>
                                </Text>
                            </HStack>
                        )}
                        {weightedAvgData.state !== undefined && (
                            <HStack spacing="clamp(4px, 0.6vw, 6px)">
                                <Box 
                                    w="clamp(6px, 0.8vw, 7px)"
                                    h="clamp(6px, 0.8vw, 7px)"
                                    borderRadius="full" 
                                    bg={AppColors.gray}
                                    flexShrink={0}
                                />
                                <Text 
                                    fontSize="clamp(9px, 1.2vw, 11px)"
                                    color="gray.700"
                                >
                                    State: <strong>{weightedAvgData.state}</strong>
                                </Text>
                            </HStack>
                        )}
                    </VStack>
                )}
            </Box>
        )}
        <CQLineChart
            chartData={[
                {
                    label: practiceChartData.text ? practiceChartData.text : 'Practice',
                    data: practiceChartData?.data,
                    borderColor: AppColors.primary,
                    backgroundColor: AppColors.primary,
                    tension: 0.4,
                },
                {
                    label: auditChartData.text ? auditChartData.text : 'Audit',
                    data: auditChartData?.data,
                    borderColor: AppColors.secondary,
                    backgroundColor: AppColors.secondary,
                    tension: 0.4,
                },
                {
                    label: stateChartData.text ? stateChartData.text : 'State',
                    data: stateChartData?.data,
                    borderColor: AppColors.gray,
                    backgroundColor: AppColors.gray,
                    tension: 0.4,
                },
            ]}
            xAxis={stateChartData.label}
            optionProps={{
                plugins: {
                    legend: {
                        ...(tile ? {} : { onClick: () => { } }),
                        display: true,
                        position: 'bottom',
                        align: 'end',
                        labels: {
                            boxWidth: 20,
                            boxHeight: 0.5,
                            color: 'black',
                            font: {
                                size: 10,
                                family: FONT_FAMILY.ptSans,
                            },
                        },
                    },
                    tooltip: {
                        callbacks: {
                            label: function(context) {
                            const value = context.raw;
                            return `${context.dataset.label}: ${value.toFixed(1)}%`; // tooltip as percentage
                            }
                        }
                    },
                },
                scales: {
                    y: {
                        max: 100,
                        beginAtZero: true,
                        ticks: {
                            // Include a dollar sign in the ticks
                            callback: function (value, index, ticks) {
                                return value + '%';
                            },
                            color: 'black',
                            font: {
                                family: FONT_FAMILY.ptSans,
                                size: 10,
                            }
                        },
                    },
                    x: {
                        beginAtZero: true,
                        ticks: {
                            color: 'black',
                            font: {
                                family: FONT_FAMILY.ptSans,
                                size: 10,
                            }
                        },
                    }
                },
            }}
        />
        </>
)}
        <VStack spacing={4} align="center">
            <Box w="full" display="flex" justifyContent="flex-end" paddingRight={2}>
            {(extraDetails?.clientStates) &&
                (extraDetails?.clientSpecalties) && (
                <Tooltip
                    bg="whiteAlpha.900"
                    color="black"
                    borderRadius="md"
                    border="1px solid #43dde0"
                    label={
                        <div>
                            <div><b>States:</b> {extraDetails?.clientStates.join(', ')}</div>
                            <div><b>Specialties:</b> {extraDetails?.clientSpecalties.join(', ')}</div>
                            <div><b>Year:</b> {extraRVUData?.year}</div>
                        </div>
                    }
                    placement="left"
                >
                    <Text fontSize="10px" cursor="pointer">
                        {`${extraDetails?.clientStates[0] || ''}${extraDetails?.clientStates.length > 1 ? '..' : ''}, ` +
                        `${extraDetails?.clientSpecalties[0] || ''}${extraDetails?.clientSpecalties.length > 1 ? '..' : ''}, ` +
                        `${extraRVUData?.year || ''}`}
                    </Text>
                </Tooltip>
            )}
            </Box>
            <HStack position="relative" w="full" justifyContent="center">
                <Box onClick={(e) => {
                    e.stopPropagation()
                }}>
                    {isRVUOppDropdownLoading ? 
                    (<Text>
                        Loading Options
                    </Text>) : (
                        dropdown.length ? <CQSelect
                        options={dropdown}
                        placeholder='Select Option'
                        variant='primary'
                        isSearchable={false}
                        styles={commonSelectStyles}
                        value={dropdown.find(option => option.value === checked)}
                        onChange={(data) => {
                            setRVUFetchTrigger(rvuFetchTrigger + 1)
                            radioClick(data.value)
                        }}
                        isLoading={isRVUOppLoading}
                        isDisabled={isRVUOppLoading}
                    /> : <Center>
                        No data present for this account
                    </Center>
                    )}
                </Box>

                <Tooltip label="Reset Filters" hasArrow placement="bottom">
                    <RepeatIcon
                        position="absolute"
                        right="0"
                        top="50%"
                        transform="translateY(-50%)"
                        boxSize={5}
                        cursor="pointer"
                        onClick={async (e) => {
                            e.stopPropagation()
                            setEandMSelectedOptions(DEFAULT_EANDM_OPTIONS);
                            setChecked(dropdown.find(option => option.value === DEFAULT_RVU_DOPDOWN).value)
                            const newFilters = {
                                billed_state_id: 0,
                                reviewed_state_id: 0, 
                                billed_specialty_id: 0,
                                reviewed_specialty_id: 0,
                                cms_state_id: 0,
                                cms_specialty_id: 0,
                                rvu_opportunity_type: DEFAULT_RVU_DOPDOWN
                            }
                            setRVUOppFilter(newFilters)
                            getRVUOpp(newFilters)
                        }}
                        sx={{
                            transform: 'translateY(-50%)',
                            animation: isRVUOppLoading ? 'spin 1s linear infinite' : undefined,
                            '@keyframes spin': {
                                to: { transform: 'translateY(-50%) rotate(360deg)' },
                            },
                        }}
                    />
                </Tooltip>
            </HStack>
            {tile && (
                <>
                <Grid
                templateColumns="18% 35% 38%"
                w="100%"
                gap={2}
                alignItems="center"
                px={1}
                py={0}
                borderRadius="md"
                >
                <Text
                fontFamily={FONT_FAMILY.baiJamurjee}
                fontSize={16}
                fontWeight="bold"
                >
                    Client Data:
                </Text>
                <DropdownComponent 
                options={stateSpecialtiesMapping?.order?.map(id => ({label: stateSpecialtiesMapping?.states?.[id]?.name, value: id}))}
                selected={eandmSelectedOptions?.selectedClientState}
                setSelected={updatedData => {
                    setEandMSelectedOptions(prev => ({...prev, selectedClientState: updatedData ? updatedData : DEFAULT_CLIENT_STATE}))
                    
                }}
                placeholder="Client States"
                isDisabled={isRVUOppLoading}
                isLoading={isRVUOppLoading}
                />
                <DropdownComponent 
                options={(stateSpecialtiesMapping?.states?.[eandmSelectedOptions?.selectedClientState.value]?.specialties ?? []).map(spec => ({value: spec.id, label: spec.name}))}
                selected={eandmSelectedOptions?.selectedClientSpecialty}
                setSelected={updatedData => {
                    setEandMSelectedOptions(prev => ({...prev, selectedClientSpecialty: updatedData ? updatedData : DEFAULT_CLIENT_SPECIALTY}));
                    
                    
                }}
                placeholder="Client Specialties"
                isDisabled={isRVUOppLoading}
                isLoading={isRVUOppLoading}
                />
            </Grid>
            <Grid
                templateColumns="18% 35% 38%"
                w="100%"
                alignItems="center"
                px={1}
                py={0}
                gap={2}
                borderRadius="md"
                >
                <Text
                fontFamily={FONT_FAMILY.baiJamurjee}
                fontSize={16}
                fontWeight="bold"
                >
                    CMS Data: 
                </Text>
                <DropdownComponent 
                options={(allStates ?? []).map(state => ({value: state.id, label: state.name}))}
                selected={eandmSelectedOptions?.selectedCMSState}
                setSelected={updatedData => {
                    setEandMSelectedOptions(prev => ({...prev, selectedCMSState: updatedData ? updatedData : DEFAULT_CMS_STATE}));
                    // setSelectedCMSpecialty(DEFAULT_CMS_SPECIALTY)
                }}
                placeholder="CMS states"
                isDisabled={isRVUOppLoading}
                isLoading={isRVUOppLoading}
                />
                <DropdownComponent 
                options={(allSpecialties ?? []).map(state => ({value: state.id, label: state.name}))}
                selected={eandmSelectedOptions?.selectedCMSSpecialty}
                setSelected={updatedData => {
                    setEandMSelectedOptions(prev => ({...prev, selectedCMSSpecialty: updatedData ? updatedData : DEFAULT_CMS_SPECIALTY})); 
                }}
                placeholder="CMS Specs"
                isDisabled={isRVUOppLoading}
                isLoading={isRVUOppLoading}
                />
            </Grid>
            <Button
            onClick={async () => {
                await getRVUOpp();
            }}
            isLoading={isRVUOppLoading}
            >
                Apply Filters
            </Button>
            </>
            )}
        </VStack>
    </Box>
}
export default RVUOpportunityV2